<script setup>
import HelpChat from "./components/HelpChat.vue";
import { useAuthStore } from "./stores/useAuthStore";
import { useLoadingStore } from "./stores/useLoadingStore";
import { useMessageStore } from "./stores/useMessageStore";

const authStore = useAuthStore();
const loadingStore = useLoadingStore();
const messageStore = useMessageStore();
</script>

<template>
  <v-app ref="app">
    <v-snackbar
      v-for="message in messageStore.messages"
      :key="message.id"
      :color="message.type || 'info'"
      :model-value="true"
      :timeout="message.timeout || 7000"
      @update:model-value="messageStore.remove(message.id)"
      location="top right"
      class="mt-5"
    >
      {{ message.key ? $t(message.key, message.params) : message.message }}
      <v-icon color="white" v-if="message.reactionAddons">{{ message.reactionAddons.type }}</v-icon>
    </v-snackbar>
    <v-overlay :model-value="loadingStore.loading" opacity="0.7" class="align-center justify-center">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <router-view />
    <HelpChat v-if="authStore.me" />
    <v-footer color="#A6ADB4" class="footer text-caption text-white py-3 py-md-2 flex-grow-0">
      <v-row no-gutters class="align-center">
        <v-col cols="12" md="auto" class="text-center mx-3 text-md-left"><img src="/assets/alvarum-white.svg" height="20px" /></v-col>
        <v-col cols="12" md="auto" class="text-center mx-3 text-md-right">
          &#169; {{ new Date().getFullYear() }}
          <a href="https://www.alvarum.com" class="text-white font-weight-bold text-decoration-none">Alvarum</a>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="auto" class="text-center mx-3">
          <a :href="$t('footer.help.link')" class="text-white text-decoration-none">{{ $t("footer.help.text") }}</a>
        </v-col>
        <v-col cols="12" md="auto" class="text-center mx-3">
          <a :href="$t('footer.terms_and_conditions.link')" class="text-white text-decoration-none">{{ $t("footer.terms_and_conditions.text") }}</a>
        </v-col>
        <v-col cols="12" md="auto" class="text-center mx-3">
          <a :href="$t('footer.privacy.link')" class="text-white text-decoration-none">{{ $t("footer.privacy.text") }}</a>
        </v-col>
        <v-col cols="12" md="auto" class="text-center mx-3">
          <a :href="$t('footer.imprint.link')" class="text-white text-decoration-none">{{ $t("footer.imprint.text") }}</a>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-footer>
  </v-app>
</template>

<style>
html,
body {
  min-height: 100vh;
}

.show-only-on-hover {
  opacity: 0;
}

td:hover .show-only-on-hover {
  opacity: 1;
}

#app {
  background: #ebeded;
  min-height: 100vh;
}

.footer {
  min-height: 60px;
}
</style>
